export enum EElectronicTrading {
  WithTrading = 1,
  WithoutTrading = 2,
}
